import React from "react";
import { Link } from "react-router-dom";
import { Zap, Cpu, CircuitBoard, KeyRound, Instagram, Ghost } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { BRAND } from "@/lib/api";
import { RedButton, GhostButton } from "@/components/Layout";

const PILLARS = [
  { Icon: Zap, title: "Reprogrammation" },
  { Icon: Cpu, title: "Clonage ECU / TCU" },
  { Icon: CircuitBoard, title: "Modules électroniques" },
  { Icon: KeyRound, title: "Clés & anti-démarrage" },
];

export default function Home() {
  const { settings } = useSite();
  const s = settings || {};

  return (
    <div data-testid="home-page">
      <section className="bg-black" data-testid="hero-section">
        <img src={BRAND.heroBanner} alt="SHRAL'AUTO" data-testid="hero-banner-image"
             className="hidden md:block w-full h-auto" />
        <img src={BRAND.heroBanner} alt="SHRAL'AUTO" data-testid="hero-banner-image-mobile"
             className="md:hidden w-full h-[280px] object-cover object-center" />
      </section>

      <section className="mx-auto max-w-[1400px] px-4 md:px-8 py-16 md:py-24">
        <div className="grid gap-px bg-zinc-800 sm:grid-cols-2 lg:grid-cols-4">
          {PILLARS.map(({ Icon, title }, i) => (
            <div key={title} className="bg-[#0a0a0a] p-5 md:p-10 hover:bg-black transition-colors"
                 data-testid={`pillar-${i}`}>
              <Icon size={28} className="text-sared" strokeWidth={1.6} />
              <h2 className="mt-4 md:mt-6 text-base md:text-lg text-white">{title}</h2>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-wrap gap-4">
          <Link to="/rendez-vous"><RedButton data-testid="home-rdv-cta">Prendre rendez-vous</RedButton></Link>
          <Link to="/planning"><GhostButton data-testid="home-planning-cta">Voir le planning</GhostButton></Link>
        </div>
      </section>

      {(s.social_instagram || s.social_snapchat) && (
        <section className="border-t border-zinc-900 bg-[#050505]" data-testid="home-social-section">
          <div className="mx-auto max-w-[1400px] px-4 md:px-8 py-14 flex flex-wrap gap-4">
            {s.social_instagram && (
              <a href={s.social_instagram} target="_blank" rel="noreferrer" data-testid="home-instagram-cta">
                <GhostButton className="flex items-center gap-3"><Instagram size={18} /> @shral_auto</GhostButton>
              </a>
            )}
            {s.social_snapchat && (
              <a href={s.social_snapchat} target="_blank" rel="noreferrer" data-testid="home-snapchat-cta">
                <GhostButton className="flex items-center gap-3"><Ghost size={18} /> shralauto</GhostButton>
              </a>
            )}
          </div>
        </section>
      )}
    </div>
  );
}
